<template>
  <modal
    name="content-modal"
    height="auto"
    :adaptive="true"
    @before-open="beforeOpen"
  >
    <div class="content-modal">
      <MainVideo v-if="type === 'video'" :video-id="videoId" preview-quality="maxresdefault" />
      <div v-else-if="type === '360'" class="content-modal__360">
        <iframe
          :src="iframe360Src"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <button @click.stop="$modal.hide('content-modal')" class="modal__close" :aria-label="$t('modal_close')"></button>
    </div>
  </modal>
</template>

<script>
import MainVideo from '../../components/product/product-page/video-gallery/MainVideo'
export default {
  name: 'ContentModal',
  components: { MainVideo },
  data () {
    return {
      type: '',
      videoId: '',
      iframe360Src: ''
    }
  },
  methods: {
    beforeOpen (event) {
      this.type = event.params && event.params.type ? event.params.type : ''
      this.videoId =
        event.params && event.params.videoId ? event.params.videoId : ''
      this.iframe360Src =
        event.params && event.params.iframe360Src
          ? event.params.iframe360Src
          : ''
    }
  }
}
</script>
<style lang="sass">
div[data-modal="content-modal"]
  .v--modal
    left: auto !important
    width: auto !important
    max-width: max-content !important
    margin: 0 auto !important
</style>
<style scoped lang="sass">

$size-1px: 0.052083333333333336vw
$size-1px-mobile: 0.2777777777777778vw
$mobile: 768

.content-modal
  position: relative
  width: $size-1px * 1400

  +mmax($mobile)
    width: $size-1px-mobile * 330

.content-modal__360
  width: 100%
  background-color: #000
  position: relative
  overflow: hidden
  cursor: pointer
  padding-bottom: 56.25%
  height: 0

  +mmax($mobile)
    padding-top: 90%
    padding-bottom: 90%

  iframe
    position: absolute
    height: 100%
    width: 100%
    top: 0
    left: 0

.modal__close
  cursor: pointer
  position: absolute
  display: block
  width: 20px
  height: 20px
  top: 10px
  right: 10px
  opacity: .5
  border: 0
  padding: 0
  background-color: transparent

  &:hover
    opacity: 1

  &:before,
  &:after
    content: ''
    position: absolute
    top: 0
    left: 50%
    height: 19px
    width: 2px
    background-color: #fff

  &:before
    transform: rotate(45deg)

  &:after
    transform: rotate(-45deg)
</style>
